import MemberMeshWarp from './MemberMeshWarp';

export default class MemberSection {
  constructor() {
    this.warp = new MemberMeshWarp();
    this.memberItems = [];
    this.hoveredMemberId = null;

    this.memberItems = Array.from(document.querySelectorAll('.member-item'));

    this._initHoverEvents();
    this._loadLandmarks();
  }

  _initHoverEvents() {
    this.memberItems.forEach(item => {
      const memberId = item.dataset.memberId;
      const photoEl = item.querySelector('.member-item__photo');
      const imgEl = item.querySelector('.member-item__img');

      if (!photoEl || !imgEl) return;

      item.addEventListener('mouseenter', () => {
        this.hoveredMemberId = memberId;
        this.warp.startWarp(memberId, photoEl, imgEl);
      });

      item.addEventListener('mousemove', (e) => {
        if (this.hoveredMemberId !== memberId) return;
        const rect = photoEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        this.warp.onMouseMove(x, y);
      });

      item.addEventListener('mouseleave', () => {
        this.hoveredMemberId = null;
        this.warp.stopWarp(false);
      });
    });
  }

  async _loadLandmarks() {
    await this.warp.loadLandmarks();
    this.memberItems.forEach(item => {
      const memberId = item.dataset.memberId;
      if (!this.warp.hasLandmarks(memberId)) {
        item.classList.add('no-warp');
      }
    });
  }
}
